import React, {Component} from "react"

import ProfilePicture from "@irati/ui/src/ProfilePicture"
import {injectIntl} from "@irati/utils/lang"
import {Label} from "@irati/ui/src/Typography"
import {CompanyValueList, User} from "@irati/types"

import {InnerWrapper, PicturesWrapper, RemainingCountNumber, Image} from "./styled"

interface Props {
  users?: User[]
  values?: CompanyValueList
  size?: number
  maxNumber?: number
}

class PictureGroup extends Component<Props> {
  static defaultProps = {
    size: 32,
    maxNumber: 5
  }

  buildUsers = () => {
    const {users, maxNumber} = this.props

    if (users.length <= maxNumber) {
      return users
    }
    const usersToShow = users.slice(0, maxNumber)
    return [...usersToShow, {uuid: "remainingUsers", remainingTotal: users.length - usersToShow.length}]
  }

  buildValues = () => {
    const {values, maxNumber} = this.props
    const valuesToRender = values.reduce((arr, value) => {
      const spreadValue = Array.from({length: value.count}, () => value.icon)
      return [...arr, ...spreadValue]
    }, [])

    if (valuesToRender.length <= maxNumber) {
      return valuesToRender
    }

    const valuesToShow = valuesToRender.slice(0, maxNumber)
    return [...valuesToShow, {uuid: "remainingValues", remainingTotal: valuesToRender.length - valuesToShow.length}]
  }

  render() {
    const {users, size} = this.props
    const picturesToRender = users ? this.buildUsers() : this.buildValues()

    return (
      <InnerWrapper size={size}>
        {picturesToRender?.map((picture, index) => (
          <PicturesWrapper key={picture.uuid} index={index}>
            {picture?.remainingTotal ? (
              <RemainingCountNumber alignItems="center" justifyContent="center" size={size}>
                <Label small color="white">
                  +{picture.remainingTotal}
                </Label>
              </RemainingCountNumber>
            ) : (
              <>
                {users ? (
                  <ProfilePicture user={picture} size={size} />
                ) : (
                  <Image width={size} height={size} src={picture.href} alt={picture.alt} />
                )}
              </>
            )}
          </PicturesWrapper>
        ))}
      </InnerWrapper>
    )
  }
}

export default injectIntl(PictureGroup)
